import { useSelector } from 'react-redux';
import { RootState } from '@/reduxStore/rootReducer';
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    AccordionSummaryText,
    KeyValueViewer,
} from '@monavate/ui-core';
import {
    createBankSupplierObject,
    createCardSupplierObject,
    hasDataToDisplayInKeyValueComponent,
} from '../../helper';
import React from 'react';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

interface SupplierSectionProps {
    paymentInfo: any;
}

const SupplierSection: React.FC<SupplierSectionProps> = ({ paymentInfo }) => {
    const transactionDetailToDisplay = useSelector(
        (state: RootState) => state.transaction.transactionDetailToDisplay,
    );
    const isCardSectionDisplay = transactionDetailToDisplay.type === 'card';
    const isBankSectionDisplay =
        transactionDetailToDisplay.type === 'bank' &&
        (transactionDetailToDisplay.bankTransaction?.bankTransactionType === 'bankTransfer' ||
            transactionDetailToDisplay.bankTransaction?.bankTransactionType === 'refund');

    if (!isCardSectionDisplay && !isBankSectionDisplay) return null;

    return (
        <Accordion defaultExpanded>
            <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="supplier-content"
                id="supplier-header"
            >
                <AccordionSummaryText>
                    {isCardSectionDisplay ? 'Supplier / card acceptor' : 'Supplier'}
                </AccordionSummaryText>
            </AccordionSummary>
            <AccordionDetails>
                {isCardSectionDisplay && (
                    <KeyValueViewer
                        data={createCardSupplierObject(transactionDetailToDisplay, paymentInfo)}
                    />
                )}
                {isBankSectionDisplay && (
                    <KeyValueViewer data={createBankSupplierObject(transactionDetailToDisplay)} />
                )}
            </AccordionDetails>
        </Accordion>
    );
};

export default SupplierSection;
